// extracted by mini-css-extract-plugin
export default {"container":"I7w6M","innerContainer":"cVm1A"};